export default __webpack_public_path__ + "static/media/ycBrand.2c76a40e.png";